import { create } from 'zustand';

export const useShittyMapStore = create((set, get) => ({
  selectedCity: null,
  setSelectedCity: (city) => set({ selectedCity: city }),

  hoveredCity: null,
  setHoveredCity: (city) => set({ hoveredCity: city }),

  filters: {
    searchQuery: '',
    upgrade: '',
    blockCount: '',
  },
  setFilter: (key, value) =>
    set((state) => ({
      filters: { ...state.filters, [key]: value },
    })),
  clearFilters: () =>
    set({
      filters: {
        searchQuery: '',
        upgrade: '',
        blockCount: '',
      },
      highlightedCities: [],
    }),

  highlightedCities: [],
  setHighlightedCities: (indices) => set({ highlightedCities: indices }),

  detailPanelOpen: false,
  setDetailPanelOpen: (open) => set({ detailPanelOpen: open }),

  cameraPosition: { x: 0, y: 0, zoom: 2 },
  setCameraPosition: (pos) => set({ cameraPosition: pos }),

  loadingProgress: 0,
  setLoadingProgress: (progress) => set({ loadingProgress: progress }),

  isLoading: true,
  setIsLoading: (loading) => set({ isLoading: loading }),

  focusTarget: null,
  setFocusTarget: (target) => set({ focusTarget: target }),
  clearFocusTarget: () => set({ focusTarget: null }),
}));
